// extracted by mini-css-extract-plugin
export default {"cls1":"VerticalSpacer-cls1_t9h","cls2":"VerticalSpacer-cls2_ceP VerticalSpacer-cls1_t9h"};